import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { history, fetchWrapper } from '_helpers';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// create slice

const name = 'books';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState,  extraReducers });

// exports

export const booksActions = { ...slice.actions, ...extraActions };
export const booksReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        user: JSON.parse(localStorage.getItem('user')),
        error: null
    }
}


function createExtraActions() {
    const baseUrl = `https://api.webtracktechnologies.com.au:8002`;
   //const registerUrl = `${process.env.REACT_APP_API_URL}/frontend/auth/register/step-1`;

    return {
        getLibraryBookHomework: getLibraryBookHomework(),
    };    

    function getLibraryBookHomework() {
        return createAsyncThunk(
            `${name}/books`,
            async ({library_id,teacher_id,date,student_id,class_id}) => await fetchWrapper.get(`${baseUrl}/books/homework/`+library_id+'?teacher_id='+teacher_id+'&date='+date+'&student_id='+student_id+'&class_id='+class_id)
        );
    }

}

function createExtraReducers() {
    return {
        ...getLibraryBookHomework(),
    };

    function getLibraryBookHomework() {
        var { pending, fulfilled, rejected } = extraActions.getLibraryBookHomework;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const bookHomework = action.payload;
              //console.log(user,'get register user');  return false;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('bookHomework', JSON.stringify(bookHomework));
                state.bookHomework = bookHomework;

            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

}
